export type CarrierListColumnKey =
  | "actions"
  | "status"
  | "carrier"
  | "phone"
  | "email"
  | "cityState"
  | "country"
  | "repAccount"
  | "fleetSize"
  | "shippeoOnboarded"
  | "lastActivity"
  | "lastDelivered"
  | "note"
  | "marketplace";

export type CarrierListColumn = {
  key: CarrierListColumnKey;
  text: string;
  isAlwaysVisible?: boolean;
};

export const carrierListColumns: CarrierListColumn[] = [
  { key: "actions", text: "", isAlwaysVisible: true },
  { key: "status", text: "Status" },
  { key: "carrier", text: "Carrier", isAlwaysVisible: true },
  { key: "phone", text: "Phone" },
  { key: "email", text: "Email" },
  { key: "cityState", text: "City/State" },
  { key: "country", text: "Country" },
  { key: "repAccount", text: "Rep Account" },
  { key: "fleetSize", text: "Fleet Size" },
  { key: "shippeoOnboarded", text: "Shippeo Onboarded" },
  { key: "lastActivity", text: "Last Activity" },
  { key: "lastDelivered", text: "Last Delivered" },
  { key: "note", text: "Note" },
  { key: "marketplace", text: "Marketplace" },
];

export const hideableCarrierListColumns = carrierListColumns.filter(
  (column) => !column.isAlwaysVisible
);

export const allCarrierListColumnKeys = carrierListColumns.map(
  (column) => column.key
);
